import { render, staticRenderFns } from "./componentMenuPromo.vue?vue&type=template&id=ac16352a&scoped=true"
import script from "./componentMenuPromo.vue?vue&type=script&lang=js"
export * from "./componentMenuPromo.vue?vue&type=script&lang=js"
import style0 from "./componentMenuPromo.vue?vue&type=style&index=0&id=ac16352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac16352a",
  null
  
)

export default component.exports